<form [formGroup]="form" class="form">
    <mat-form-field *ngIf="items && items.length > 1">
        <mat-label>Select your payment method</mat-label>
        <mat-select formControlName="method">
            <mat-option *ngFor="let item of items" [value]="item">{{item.bankInfo?.bankName || '---'}} ****{{item.stripeLast4}}</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field>
        <mat-label>Start date</mat-label>
        <input matInput type="date" formControlName="startDate" min="1970-01-01">
    </mat-form-field>
    <mat-form-field>
        <mat-label>End date</mat-label>
        <input matInput type="date" formControlName="endDate" min="1970-01-01">
    </mat-form-field>
    <button mat-button type="button" (click)="clearDates()" [disabled]="!form.get('startDate').value && !form.get('endDate').value">Clear dates</button>
</form>
<p class="date-hint">Dates are inclusive and shown in {{ displayTimezone }}.</p>
<p role="alert" *ngIf="dateError">{{ dateError }}</p>
<span class="mandatetext" *ngIf="isLoading">Loading Charge History…</span>
<div class="mandatetext" role="alert" *ngIf="loadError">
    {{loadError}}
    <button mat-button type="button" (click)="retryPage()" *ngIf="form.get('method').value">Retry</button>
</div>
<span class="mandatetext" *ngIf="!isLoading && !loadError && hasLoadedPage && invoices.length === 0 && invoicesWithoutPaymentMethod.length === 0">No charges match this payment method and date range.</span>
<span class="title" *ngIf="invoicesWithoutPaymentMethod && invoicesWithoutPaymentMethod.length > 0">Invoices without a payment method</span>
<div *ngIf="invoicesWithoutPaymentMethod && invoicesWithoutPaymentMethod.length > 0">
    <app-stripe-chargehistory-table [invoices]="invoicesWithoutPaymentMethod"></app-stripe-chargehistory-table>
</div>
<span class="title" *ngIf="invoices && invoices.length > 0">Invoices with a payment method</span>
<div *ngIf="invoices && invoices.length > 0">
    <app-stripe-chargehistory-table [invoices]="invoices"></app-stripe-chargehistory-table>
</div>

<nav class="pagination" aria-label="Charge History pages" *ngIf="hasLoadedPage || isLoading || (loadError && form.get('method').value)">
    <button mat-stroked-button type="button" (click)="previousPage()" [disabled]="isLoading || !!loadError || pageIndex === 0">Previous</button>
    <span aria-live="polite">Page {{ pageIndex + 1 }}<ng-container *ngIf="hasLoadedPage && !hasMore"> · Last page</ng-container></span>
    <button mat-stroked-button type="button" (click)="nextPage()" [disabled]="isLoading || !!loadError || !hasMore">Next</button>
    <span>50 records per page</span>
</nav>
